import { PlaceholderPage } from '@/components/molecules/PlaceholderPage';
import { usePaymentsPage } from './usePaymentsPage';

export function PaymentsPage() {
  const { title, description } = usePaymentsPage();

  return <PlaceholderPage title={title} description={description} />;
}
